// extracted by mini-css-extract-plugin
export default {"container":"ci-z","links":"di-z"};